import { BrowserRouter, Routes, Route } from "react-router-dom";

import { FileProvider } from "./Contexts";
import Layout from "./Layout";
import About from "./pages/About";
import NL2BLTL from "./pages/NL2BLTL";
import BioRECIPE from "./pages/Biorecipe";
import Celesta from "./pages/Celesta";
import Dish from "./pages/Dish";
import Home from "./pages/Home";
import Violin from "./pages/Violin";
import Kalimba from "./pages/Kalimba";
import Motif from "./pages/Motif";
// import Bell from "./pages/Bell";
import Analyzer from "./pages/Analyzer";

// import Bell from "./components/BellApp";

export default function App() {
  return (
    <FileProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="dish" element={<Dish />} />
            <Route path="violin" element={<Violin />} />
            <Route path="celesta" element={<Celesta />} />
            <Route path="nl2bltl" element={<NL2BLTL />} />
            <Route path="biorecipe" element={<BioRECIPE />} />
            <Route path="kalimba" element={<Kalimba />} />
            <Route path="about" element={<About />} />
            {/* <Route path="bell" element={<Bell />} /> */}
            {/* <Route path="motif" element={<Motif />} /> */}

            {/* <Route path="bell" element={<Bell />} /> */}
            <Route path="analyzer" element={<Analyzer />} />

          </Route>
        </Routes>
      </BrowserRouter>
    </FileProvider>
  );
}
